import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  usersSignUpAction,
  usersLogInAction,
  usersLogOutAction,
  usersFetchCurrentUserAction,
  userslogOutSuccess,
  userslogOutError,
} from './sessionActions';

import { closeModalLogOut } from '../global/globalActions';
import axios from 'axios';
import { toast } from 'react-toastify';
axios.defaults.baseURL = 'https://project-wallet-main.herokuapp.com';

const token = {
  set(token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  },
  unset() {
    axios.defaults.headers.common.Authorization = '';
  },
};

export const register = createAsyncThunk(
  usersSignUpAction,
  async (credentials, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`/users/signup`, credentials);
      //  token.set(data.emailVerificationToken);

      toast('Registration successful.', { theme: 'colored', type: 'Success' });
      return data;
    } catch (error) {
      console.log('error', error.message);

      if (error.message === 'Request failed with status code 409') {
        toast.error('Email is already in use. Login please!', {
          theme: 'colored',
        });
      } else {
        toast.error('Something is wrong. Try again later', {
          theme: 'colored',
        });
      }
      return rejectWithValue(error.message);
    }
  },
);

export const logIn = createAsyncThunk(
  usersLogInAction,
  async (credentials, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`/users/login`, credentials);
      token.set(data.token);
      toast(`Hello, ${data.user.name}!`, { theme: 'colored', type: 'success' });
      return data;
    } catch (error) {
      toast.error(
        `Login failed. Check the correctness of the entered data. Or register.`,
        {
          theme: 'colored',
        },
      );
      return rejectWithValue(error.message);
    }
  },
);

export const logOut = createAsyncThunk(
  usersLogOutAction,
  async (_, { rejectWithValue }) => {
    try {
      await axios.post(`/users/logout`);
      token.unset();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchCurrentUser = createAsyncThunk(
  usersFetchCurrentUserAction,
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const persistedToken = state.session.token;
    if (persistedToken === null) {
      return thunkAPI.rejectWithValue('there is no token');
    }

    token.set(persistedToken);
    try {
      const { data } = await axios.get(`/users/current`);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);
